import { getApi } from "../apis";

// get user details
export const getUserDetails = (userId) => getApi(`user?userId=${userId}`);